<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="profile__content" :class="{ profile__minimized: minimized }">
        <b-skeleton
          v-if="loading"
          class="profile__image margin-bottom-0"
          :width="minimized ? '100%' : '15%'"
        ></b-skeleton>
        <b-skeleton
          v-if="loading && !minimized"
          class="profile__name margin-bottom-0"
          width="85%"
        ></b-skeleton>
      </div>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
